import type { IShapeOfField } from "@/utils/zod";
import { z } from "@/utils/zod";

export interface IResetPasswordFormSchema {
  newPassword: string;
  confirmNewPassword: string;
}

export const resetPasswordFormInitialValues: IResetPasswordFormSchema = {
  newPassword: "",
  confirmNewPassword: "",
};

export const resetPasswordFormValidationSchema = z
  .object<IShapeOfField<IResetPasswordFormSchema>>({
    newPassword: z.string().min(8),
    confirmNewPassword: z.string().min(8),
  })
  .superRefine((values, ctx) => {
    const password = values.newPassword as string;

    if (!/[A-Z]/.test(password)) {
      ctx.addIssue({
        code: "custom",
        path: ["newPassword"],
        params: { i18n: "changePasswordFormError.upperCase" },
      });
    }

    if (!/\d/.test(password)) {
      ctx.addIssue({
        code: "custom",
        path: ["newPassword"],
        params: { i18n: "changePasswordFormError.number" },
      });
    }

    if (values.newPassword !== values.confirmNewPassword) {
      ctx.addIssue({
        code: "custom",
        path: ["confirmNewPassword"],
        params: { i18n: "changePasswordFormError.match" },
      });
    }
  });
